import React, { Fragment } from 'react';

const TripRequest = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      There are several possible reasons why you are not receiving any
      trip/delivery requests:
    </p>
    <ol>
      <li>
        <strong>Low demand:</strong> There is currently less demand for
        rideshare services in your current area. Try avoiding areas where
        there is surge pricing or higher than expected demand which can be
        determined by using the Uber Driver app.
      </li>
      <li>
        <strong>PTC license issue:</strong> All Autzu vehicles have an
        active PTC license. An active PTC license is also required for each
        individual person in order for you to receive trip requests. If you
        are unable to receive trip requests after being “online” for many
        hours, you will need to reach out to Uber Support (1-800-593-7069)
        or go to an in-person Uber Greenlight Hub location to resolve the
        PTC issue.
      </li>
      <li>
        <strong>Poor Network Connection/Data Plan:</strong> You may be
        having difficulties with connecting with your service provider or
        your data plan is not sufficient.
      </li>
    </ol>
  </Fragment>
);

export default TripRequest;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccountIssues/TripRequest.js